<template>
  <div class="wrap">
    <div class="input_wrap">
      <div style="display: flex;gap: 24rem;align-items: center; ">
        <el-input placeholder="请输入题目ID"
                  v-model="keywords"
                  style="width:400rem;">
          <i slot="suffix"
             @click="searchTopic"
             class="el-input__icon el-icon-search"
             style="font-size:20rem;pointer:cursor"></i>
        </el-input>
        <div style="height: 48rem;display: flex;justify-content: center;align-items: center;cursor: pointer;"  >
        <el-badge :value="unreadMsgCount" :max="99" :hidden="parseInt(unreadMsgCount)==0" @click="toMsg">
        <svg width="32rem" height="32rem" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" @click="toMsg">
          <path d="M15.625 0.75C11.4824 0.754549 7.51075 2.40221 4.58148 5.33148C1.65221 8.26075 0.00454937 12.2324 0 16.375V29.5C0 30.163 0.263392 30.7989 0.732233 31.2678C1.20107 31.7366 1.83696 32 2.5 32H15.625C19.769 32 23.7433 30.3538 26.6735 27.4235C29.6038 24.4933 31.25 20.519 31.25 16.375C31.25 12.231 29.6038 8.25671 26.6735 5.32646C23.7433 2.3962 19.769 0.75 15.625 0.75ZM15.625 29.5H2.5V16.375C2.5 13.7791 3.26977 11.2415 4.71196 9.08314C6.15415 6.92475 8.204 5.24248 10.6023 4.24908C13.0006 3.25568 15.6396 2.99576 18.1856 3.50219C20.7316 4.00862 23.0702 5.25866 24.9058 7.09422C26.7413 8.92979 27.9914 11.2684 28.4978 13.8144C29.0042 16.3604 28.7443 18.9994 27.7509 21.3977C26.7575 23.796 25.0753 25.8458 22.9169 27.288C20.7585 28.7302 18.2209 29.5 15.625 29.5ZM17.5 17C17.5 17.3708 17.39 17.7334 17.184 18.0417C16.978 18.35 16.6851 18.5904 16.3425 18.7323C15.9999 18.8742 15.6229 18.9113 15.2592 18.839C14.8955 18.7666 14.5614 18.588 14.2992 18.3258C14.037 18.0636 13.8584 17.7295 13.786 17.3658C13.7137 17.0021 13.7508 16.6251 13.8927 16.2825C14.0346 15.9399 14.275 15.647 14.5833 15.441C14.8916 15.235 15.2542 15.125 15.625 15.125C16.1223 15.125 16.5992 15.3225 16.9508 15.6742C17.3025 16.0258 17.5 16.5027 17.5 17ZM10.625 17C10.625 17.3708 10.515 17.7334 10.309 18.0417C10.103 18.35 9.81014 18.5904 9.46753 18.7323C9.12492 18.8742 8.74792 18.9113 8.3842 18.839C8.02049 18.7666 7.6864 18.588 7.42417 18.3258C7.16195 18.0636 6.98337 17.7295 6.91103 17.3658C6.83868 17.0021 6.87581 16.6251 7.01773 16.2825C7.15964 15.9399 7.39996 15.647 7.70831 15.441C8.01665 15.235 8.37916 15.125 8.75 15.125C9.24728 15.125 9.72419 15.3225 10.0758 15.6742C10.4275 16.0258 10.625 16.5027 10.625 17ZM24.375 17C24.375 17.3708 24.265 17.7334 24.059 18.0417C23.853 18.35 23.5601 18.5904 23.2175 18.7323C22.8749 18.8742 22.4979 18.9113 22.1342 18.839C21.7705 18.7666 21.4364 18.588 21.1742 18.3258C20.912 18.0636 20.7334 17.7295 20.661 17.3658C20.5887 17.0021 20.6258 16.6251 20.7677 16.2825C20.9096 15.9399 21.15 15.647 21.4583 15.441C21.7666 15.235 22.1292 15.125 22.5 15.125C22.9973 15.125 23.4742 15.3225 23.8258 15.6742C24.1775 16.0258 24.375 16.5027 24.375 17Z" fill="#666666"/>
        </svg>

        </el-badge>
          <img src="@/assets/rank.png"
       @click="toRank"
       style="height: 54rem;width: 164rem;margin-left: 36rem;"
             alt="">
      </div>
      </div>

      <div class="goal_text">为理想而战<img style="margin-top: 7rem;"
             src="@/assets/medal.png"
             alt="">
        <img src="@/assets/artExam.png"
             v-if="userInfo.user_class_id == 1"
             alt="">
        <img src="@/assets/职高.png"
              v-if="userInfo.user_class_id == 2"
             alt="">
      </div>
      <div style="display:flex;gap:39rem;height: 52rem;align-items: center;">
         <button class="btn_goal">
        <div class="text"
        @click="showShcool"
             v-if="form"> 目标院校 <span style="font-size: 18rem;margin-left: 26rem;display: -webkit-box;
-webkit-box-orient: vertical;
-webkit-line-clamp: 1;overflow: hidden;
color: var(--light-ffffff, #FFF);
text-overflow: ellipsis;max-width:162rem">{{ form.college_name }}</span><span style="font-size: 18rem;margin-left: 6rem;display: -webkit-box;
-webkit-box-orient: vertical;
-webkit-line-clamp: 1;overflow: hidden;
color: var(--light-ffffff, #FFF);
text-overflow: ellipsis;max-width:100rem">{{form.professional}}</span>专业  ></div>
        <div class="text"
            @click="showShcool"
             v-else> 点击选择你的目标院校 </div>
      </button>
      <button class="btn_goal"
              @click="toGoal">
        <div class="text"
             v-if="totalScore !== 0"> 目标分数 {{ totalScore }}分 ></div>
        <div class="text"
             v-else> 快去填写{{userInfo.edu_grade_id == 3?'学科目标': '高考目标'}}> </div>
      </button>
        </div>
    </div>
    <div class="index_warp">
      <div class="left">
        <Top ref="leftRef" />
      </div>
      <div class="right">
        <Bottom ref="rightRef" />
      </div>
    </div>
    <div class="autoModal"
         v-if="autoModalFlag">
      <div class="openButton">

        <el-button type="warning"
                   @click="toBuy"
                   class="btntext"><span class="text">开通VIP享受全部功能</span></el-button>
      </div>
    </div>
    <Dialog ref="dialogRef" />
      <ScoreDialog ref="ScoreRef"></ScoreDialog>
  </div>
</template>
<script>
import Top from './components/top.vue'
import Dialog from './components/dialog.vue'
import Bottom from './components/bottom.vue'
import ScoreDialog from "@/views/index/components/scoreDialog.vue"

import { getStudentSubject } from '@/api/subject.js'
import { getTopic } from '@/api/topic.js'
import Image from '../paper_components/correct/components/image.vue'
import { messageStatus,recordUseTime } from '@/api/home.js'
import { getUserInfo,getSubmitGoalCollege } from '@/api/subject.js'
import { getVipInfo } from '@/api/vip.js'


export default {
  data () {
    return {
      keywords: '',
      autoModalFlag: false,
      totalScore: 0,
      unreadMsgCount: 0,
      userInfo: {},
      timer: null,
      timer1:null,
      form:{college_name: '',professional: ''},
    }
  },

  async mounted () {
    this.totalScore = JSON.parse(window.localStorage.getItem('totalScore'));
    this.$EventBus.on('totalScoreEdit', data => {
      this.totalScore = data
    })
    if (this.totalScore > 0) {
      window.localStorage.setItem('score_dialog', false)
    }
    let userInfo = JSON.parse(window.localStorage.getItem('userInfo'));
    this.userInfo = userInfo
    if (userInfo.user_type_id == 14 && !userInfo.vip_end_time) {
      this.autoModalFlag = true
    }

    this.getMsgUnread()
    this.reqMsgLoop()
    const timerKey = '__loginTimer__'
    if (!window[timerKey]) {
    this.getLoginStatus()
    window[timerKey] = window.setInterval(this.getLoginStatus, 60000)
  }
  this.getInfo()
  },
  methods: {
    async showShcool () {
      // this.$refs.dialogRef.dialogVisible = true
      // const { data } = await getVipInfo()
      //  if(data.user_version==0){
      //     this.$router.push('/goal3')
      //  }else{
 this.$router.push('/goal1')
      //  }
    },

       async getInfo () {
      const { data } = await getUserInfo()
      this.form.college_name = data.college_name
      this.form.professional = data.professional
    },
    toBuy () {
      this.$router.push('/buyVip')
    },
    toRank() {
this.$router.push('/studyRank')
    },
    toGoal () {
      // this.$router.push('/studyGoal')
       this.$refs.ScoreRef.dialogVisible = true
    },
    toSchoolGoal () {
      this.$router.push('/goal1')
    },
    async searchTopic () {
      const { data } = await getTopic({
        question_id: this.keywords
      })
      if (data.list && data.list.length) {
        this.$router.push('showTopic?topic_id=' + this.keywords)
      }
    },


    async getMsgUnread () {
      try {
        var res = await messageStatus({ platform: 2, client: 1, uid: this.userInfo.user_id })
      } catch (error) {
        console.log(error)
        window.clearTimeout(this.timer)
      }

      this.unreadMsgCount = res.data.unread
    },
    reqMsgLoop () {
      this.timer = window.setTimeout(async () => {
        this.getMsgUnread()
        this.reqMsgLoop()
      }, 5000)
    },
  async getLoginStatus() {
    console.log('dateee',Date.now())
      try {
        var res = await recordUseTime();
      } catch (error) {
        console.log(error);
         if (this.timer1 ) {
      window.clearTimeout(this.timer1 )
      this.timer1 = null
    }
      }
    },


    toMsg () {
      this.$router.push('/message')
    }
  },
  beforeRouteLeave (to, from, next) {
    // let keep_alive_path = ['/group_test', '/myPaper', '/analysis', '/choiceness', '/knowledge', '/wholepaper_list', '/discuss', '/chapter']
    let keep_alive_path = ['/analysis', '/discuss', '/chapter']
    if (keep_alive_path.indexOf(to.path) != -1) {
      to.meta.keep = true;
    }
    next();
  },
  destroyed () {
    window.clearTimeout(this.timer)
  },

  components: {
    Top, Bottom, Dialog,ScoreDialog
  },

}
</script>

<style lang="scss" scoped>
.autoModal {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  opacity: 1.5;
  background: linear-gradient(
    to bottom,
    rgba(255, 255, 255, 0),
    rgba(255, 255, 255, 1)
  );
  .btntext {
    position: fixed;
    left: 800rem;
    top: 700rem;
    .text {
      color: var(--light-333333, #333);
      text-align: center;

      font-size: 24rem;
      font-style: normal;
      font-weight: 600;
      line-height: 36rem; /* 150% */
    }
  }
  .openButton {
    ::v-deep .el-button {
      display: flex;
      width: 360rem;
      height: 64rem;
      justify-content: center;
      align-items: center;
      gap: 10rem;
      flex-shrink: 0;
      border-radius: 8rem;
      background: linear-gradient(100deg, #fdecc9 0%, #e9c383 100%);
      box-shadow: 0rem 8rem 16rem 0rem rgba(0, 0, 0, 0.1);
    }
  }
}
.index_warp {
  width: 100%;
  display: flex;
  // height: calc(98.5vh - 75rem);
  .left {
    display: flex;
    width: 59.9vw;
    margin-top: 1.5vh;
    height: 100%;
    margin-left: 3vw;
  }
  .right {
    flex-shrink: 0;
    width: 27.6vw;
    margin-top: 1.5vh;
    height: 100%;
    margin-left: 3vw;
  }
}
.wrap {
  width: 100%;
}
.input_wrap {
  // width: 400rem;
  // position: absolute;
  // top: 28rem;
  // right: 44rem;
  // margin-top: 20rem;
  margin-left: 3vw;
  margin-right: 3vw;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .goal_text {
    color: var(--light-333333, var(--neutral-color-333333, #333));
    font-size: 32px;
    font-style: normal;
    font-weight: 700;
    // line-height: 32px; /* 131.25% */
    display: flex;
    align-items: center;
  }
  .btn_goal {
    display: flex;
    padding: var(--spacer-8_xs, 8px) var(--spacer-24_m, 24px);
    align-items: center;
    gap: var(--spacer-8_xs, 8px);
    border-radius: 100px;
    border: 1px solid #f37f21;
    background: #f37f21;
     font-size: 20rem;
    cursor: pointer;
    .text {
      overflow: hidden;
      color: var(--light-ffffff, #fff);
      text-overflow: ellipsis;
      font-size: 18rem;
      font-style: normal;
      font-weight: 600;
         display: flex;
      line-height: 36px; /* 150% */
    }
  }
  ::v-deep .el-input--medium .el-input__inner {
    border-radius: 20rem;
    height: 44rem !important;
    line-height: 44rem;
    font-size: 18rem;
  }
  ::v-deep .el-input--medium .el-input__icon {
    margin-right: 20rem;
    line-height: 44rem;
    width: auto;
  }
}
</style>